import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['Martín', 'Lucía', 'Santiago', 'Valentina', 'Mateo', 'Camila', 'Joaquín', 'Sofía', 'Nicolás', 'Martina', 'Tomás', 'Julieta', 'Facundo', 'Micaela', 'Agustín'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const triggerNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 10) + 1; // 1 to 10 minutes ago
      setNotificationData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Stay for 4 seconds
      // Schedule next notification
      const nextInterval = Math.floor(Math.random() * (45000 - 25000 + 1)) + 25000; // 25 to 45 seconds
      setTimeout(triggerNotification, nextInterval);
    };
    // Initial trigger after a short delay
    const initialTimer = setTimeout(triggerNotification, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-257">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      transition: {
        duration: 0.3
      }
    }} className="fixed bottom-6 left-6 z-50 bg-navy-800 border-l-4 border-gold rounded-r-lg shadow-2xl p-4 pr-6 max-w-sm border-y border-r border-white/10" data-id="element-258">
          <div className="flex items-start gap-3" data-id="element-259">
            <span className="text-2xl leading-none" data-id="element-260">✅</span>
            <div data-id="element-261">
              <p className="text-white text-sm font-medium leading-snug" data-id="element-262">
                ¡<span className="text-gold" data-id="element-263">{notificationData.name}</span> de{' '}
                {notificationData.city} acaba de comprar su mazo!
              </p>
              <p className="text-white/50 text-xs mt-1" data-id="element-264">
                hace {notificationData.time} minuto
                {notificationData.time !== 1 ? 's' : ''}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}